import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import type {
  BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostData,
  BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostError,
  BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostResponse,
} from '../../generated';
import { multipartPost } from '../../utils';

export type BulkImportCsvMutationVariables = BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostData['path'] &
  BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostData['body'];

export type BulkImportCsvMutation = BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostResponse;

export const useBulkImportCsvMutation = <
  TError = BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<BulkImportCsvMutation, TError, BulkImportCsvMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<BulkImportCsvMutation, TError, BulkImportCsvMutationVariables, TContext>({
    mutationKey: ['BulkImportCsv'],
    mutationFn: ({ portfolio_id, file }: BulkImportCsvMutationVariables) =>
      multipartPost<BulkImportCsvMutation>('/v1/portfolios/{portfolio_id}/bulk-import/csv', file, { portfolio_id }),
    ...options,
  });
};
